module.exports = __webpack_public_path__ + "static/media/logo.bde93cf4.svg";